import { atom, useAtom } from "jotai";

const focusModeState = atom(false);

export function useFocusMode() {
  return useAtom(focusModeState);
}
